<script lang="ts">
	import { page } from '$app/state';
	import ChevronRight from '$lib/icons/chevronRight.svelte';

	interface Props {
		pageName: string;
		onselectCategory?: () => void;
	}

	let { pageName, onselectCategory }: Props = $props();

	let homePath = $derived(page.url.pathname.match(/^\/([^\/]*)\/([^\/]*)/)?.[1] ?? '/');
</script>

{#if page.state.selectedBlogArticleCategory}
	<nav class="col-span-full lg:col-start-2 lg:col-end-12">
		<ul
			class="flex items-center gap-x-1 text-[14px]/[110%] text-brown-3 hover:text-brown-2 lg:text-[18px]/[110%]"
		>
			<li><a href="/{homePath}">Home</a></li>
			<ChevronRight class="h-4 w-4" />
			<!-- svelte-ignore a11y_no_noninteractive_element_to_interactive_role -->
			<!-- svelte-ignore a11y_click_events_have_key_events -->
			<li role="button" onclick={() => onselectCategory?.()}>
				{page.state.selectedBlogArticleCategory.name}
			</li>
			<ChevronRight class="h-4 w-4" />
			<li class="overflow-hidden text-ellipsis whitespace-nowrap text-brown-1">{pageName}</li>
		</ul>
	</nav>
{/if}
